module.exports = __webpack_public_path__ + "img/8U.bb5a21a1.png";